import { formatMoneyValue } from '../../../../../../app/utils/formatMoneyValue'
import {
  Card,
  CardContent,
  CardHeader,
} from '../../../../../components/ui/card'
import { Spinner } from '../../../../../components/ui/spinner'
import { useCustomerCardDetailsController } from './useCustomerCardDetailsController'

type CustomerDetailsProps = {
  name: string
}

// TODO: Verificar qual dado vai prevalecer

export const CustomerCardDetails = ({ name }: CustomerDetailsProps) => {
  const { transactionData, isFetching, isLoading } =
    useCustomerCardDetailsController()

  return (
    <>
      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}
      {!isFetching && (
        <Card className="w-[100%] border-none">
          <CardHeader className="rounded-lg border-[1px] border-[#E5E5E5] bg-white02 p-5">
            <div className="flex flex-col gap-2">
              <div className="flex justify-between">
                <div className="flex w-full flex-wrap items-start justify-between">
                  <p className="text-2xl font-semibold">{name}</p>
                  <div className="h-fit w-fit rounded-3xl bg-[#FDF3D0] px-2 py-1">
                    <p className="text-xs font-semibold text-[#A68E38]">
                      Cliente
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </CardHeader>
          <CardContent className="mt-4 flex items-center justify-between gap-4 p-0">
            <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-[#E5E5E5] bg-white02 px-3 py-2">
              <p className="font-semibold">
                {transactionData?.statitics?.completed ?? 0}
              </p>
              <p className="text-xs font-medium text-black04">
                Saques realizados
              </p>
            </div>
            <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-[#E5E5E5] bg-white02 px-3 py-2">
              <p className="font-semibold">
                {formatMoneyValue(
                  transactionData?.statitics?.completed_value || 0,
                )}
              </p>
              <p className="text-xs font-medium text-black04">Movimentados</p>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  )
}
